// This file is part of InvenioRDM
// Copyright (C) 2022-2024 CERN.
//
// Invenio RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

// Overrides: 
// - removed DisplayPartOfCommunities
// - replaced viewLink with the link to the mcid view

import { i18next } from "@translations/invenio_app_rdm/i18next";
import _get from "lodash/get";
import _truncate from "lodash/truncate";
import React, { Component } from "react";
import { SearchItemCreators } from "@js/invenio_app_rdm/utils";
import PropTypes from "prop-types";
import { Item, Label, Icon } from "semantic-ui-react";
import { buildUID } from "react-searchkit";
import { CompactStats } from "@js/invenio_app_rdm/components/CompactStats";
// import { DisplayPartOfCommunities } from "@js/invenio_app_rdm/components/DisplayPartOfCommunities";

class MCARecordsResultsListItem extends Component {
  render() {
    const { currentQueryState, result, key, appName } = this.props;

    const creators = result.ui.creators.creators;

    const descriptionStripped = _get(
      result,
      "ui.description_stripped",
      "No description"
    );
    const publicationDate = _get(
      result,
      "ui.publication_date_l10n_long",
      "No publication date found."
    );
    const resourceType = _get(
      result,
      "ui.resource_type.title_l10n",
      "No resource type"
    );
    const subjects = _get(result, "ui.subjects", []);
    const title = _get(result, "metadata.title", "No title");
    const version = _get(result, "ui.version", null);
    const versions = _get(result, "versions");
    const uniqueViews = _get(result, "stats.all_versions.unique_views", 0);
    const uniqueDownloads = _get(result, "stats.all_versions.unique_downloads", 0);
    const doi = _get(result, "pids.doi.identifier", null);
    const doi_badge = "badge/DOI/" + doi + ".svg";
    const doi_url = _get(result, "links.doi", null);
    const mc_sections = _get(result, "custom_fields.mc_sections", null);

    const filters = currentQueryState && Object.fromEntries(currentQueryState.filters);
    const allVersionsVisible = filters?.allversions;
    const numOtherVersions = versions.index - 1;

    // Derivatives
    // const viewLink = `/records/${result.id}`;
    const viewLink = `/record/${result.pids["mcid"]["identifier"]}`;

    // mc_sections
    function MCsectionIcon(mc_section) {
      let mc_section_capital;
      if (mc_section.mc_section == "work_tools") {
        mc_section_capital = "Work/Tools";
      } else {
        mc_section_capital = mc_section.mc_section.charAt(0).toUpperCase() +  mc_section.mc_section.slice(1);
      }
      let icon = null;
      let width = 0;

      switch (mc_section.mc_section) {
        case "discover":
          icon = "static/images/mcloud-logo-98x79.png";
          width = 11;
          break;
        case "explore":
          icon = "static/images/aiida-logo-138x128.png";
          width = 10;
          break;
        case "work_tools":
          icon = "static/images/work_tools.png";
          width = 10;
          break;
      }
      return (
        <span
          data-tooltip={mc_section.mc_description}
          data-position="top left">
            <a href={mc_section.mc_link} target="_blank">
              <img src={icon} width={width} alt={mc_section.mc_section}/> {mc_section_capital}
            </a>
          </span>
      )
    }

    return (
        <Item key={key ?? result.id}>
          <Item.Content>
            {/*<Item.Extra className="labels-actions">
               <Label horizontal size="small" className="primary">
                {publicationDate} ({version})
              </Label>
              <Label horizontal size="small" className="neutral">
                {resourceType}
              </Label>
            </Item.Extra>*/}
            <Item.Header as="h2">
              {/* <a href={viewLink}><p dangerouslySetInnerHTML={{ __html: title }}></p></a> */}
              <a href={viewLink}>{title}</a>
            </Item.Header>

            {/* Badges doi, version, mc_sections */}
            <Item.Extra>
            {doi ?
              (
                <Item.Extra className="labels-actions">
                  <a href={`https://doi.org/${doi}`} target="_blank">
                    <img src={doi_badge} alt="DOI" className="doi_badge"/>
                  </a>
                  <Label horizontal size="small">
                    {version}
                  </Label>
                  {mc_sections ?
                    (mc_sections.map((mc_section) => (
                      <Label horizontal size="small">
                        {MCsectionIcon(mc_section)}
                      </Label>
                    )))
                  : (<></>)
                  }
                </Item.Extra>
              ) : (
                <Item.Extra className="labels-actions">
                  <Label horizontal size="small">
                    {version}
                  </Label>
                  {mc_sections ?
                    (mc_sections.map((mc_section) => (
                      <Label horizontal size="small">
                        {MCsectionIcon(mc_section)}
                      </Label>
                    )))
                  : (<></>)
                  }
                </Item.Extra>
              )
            }
            </Item.Extra>

            <Item className="creatibutors">
              <SearchItemCreators creators={creators} othersLink={viewLink} />
            </Item>
            <Item.Description>
              {_truncate(descriptionStripped, { length: 350 })}
            </Item.Description>
            <Item.Extra>
              {subjects.map((subject) => (
                <Label key={subject.title_l10n} size="tiny">
                  {subject.title_l10n}
                </Label>
              ))}

              <div className="flex justify-space-between align-items-end">
                <medium>
                  <p>
                    {version && versions.is_latest ? (
                      <>
                        {i18next.t("Latest version: {{version}}", {
                          version: version,
                        })}
                      </>
                    ) : version && (
                      <>
                        {i18next.t("Version: {{version}}", {
                          version: version,
                        })}
                      </>
                    )

                    }
                  </p>
                  <p>
                    {publicationDate && (
                      <>
                        {i18next.t("Publication date: {{pubDate}}", {
                          pubDate: publicationDate,
                        })}
                      </>
                    )}
                  </p>
                  <small>
                  {!allVersionsVisible && versions.index > 1 && (
                    <p>
                      <b>
                        {numOtherVersions > 1?
                          i18next.t("{{count}} previous versions exist for this record", {
                            count: numOtherVersions,
                          })
                         :
                          i18next.t("{{count}} previous version exists for this record", {
                            count: numOtherVersions,
                          })
                        }
                      </b>
                    </p>
                  )}
                  </small>
                </medium>

                <small>
                  <CompactStats
                      uniqueViews={uniqueViews}
                      uniqueDownloads={uniqueDownloads}
                  />
                </small>
              </div>
            </Item.Extra>
            {/* <Item.Extra>
            {doi ?
              (<Item.Extra className="labels-actions">
                  <a href={doi_url} target="_blank">
                    <img src={doi_badge} alt="DOI" width="180"/>
                  </a>
              </Item.Extra>) : (<></>)
            }
            </Item.Extra> */}
          </Item.Content>
        </Item>
    );
  }
}

MCARecordsResultsListItem.propTypes = {
  currentQueryState: PropTypes.object,
  result: PropTypes.object.isRequired,
  key: PropTypes.string,
  appName: PropTypes.string,
};

MCARecordsResultsListItem.defaultProps = {
  key: null,
  currentQueryState: null,
  appName: "",
};

export { MCARecordsResultsListItem };
